import { defineComponent as _defineComponent } from 'vue'
import {WarrantyService} from '../../../services/WarrantyService'
import {onMounted, ref} from "vue";
import {useRoute, useRouter} from 'vue-router/composables'
import i18n from "@/i18n";
import {WarrantySearchModelType} from "@/types/WarrantySearchModelType";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserList',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const userList = ref([])

onMounted(() => {
  // @ts-ignore
  const searchModel: WarrantySearchModelType = route.query
  WarrantyService.search(searchModel)
      .then(value => {
        if (value.length == 0) {
          router.push({
            name: 'warranty',
            query: { message: 'No hits found' }
          })
        }
        if (value.length == 1) {
          showDetails(value[0].id)
        }
        if (value.length > 1) {
          userList.value = value
        }
      })
      .catch(reason => {
        if (reason['errors'] !== undefined) {
          router.push({
            name: 'warranty',
            query: { message: reason['errors'] }
          })
        } else {
          console.log(reason)
          router.push({
            name: 'warranty',
            query: { message: 'default_error_message' }
          })
        }
      });
})

function showDetails(id: string) {
  router.push({
    name: 'warranty_user_detail',
    params: {id: id}
  })
}

return { __sfc: true,router, route, userList, showDetails, i18n }
}

})